export const endingCharacters = [
  {
    key: "yuki",
    name: "Yuki Tanaka",
    description:
      "She brewed quiet tea—\nWhispers turned to cherry winds.\nDon’t ask about love."
  },
  {
    key: "satoshi",
    name: "Satoshi Watanabe",
    description:
      "LOL he said, bruh—\nHaikus slap when turtles vibe.\nWanna date or nah?"
  },
  {
    key: "koji",
    name: "Koji Nakamura",
    description:
      "Sweeps tracks like old sins—\nDog watches him like Buddha.\nHairless. Also wise."
  },
  {
    key: "mari",
    name: "Mari Aoyama",
    description:
      "Haikus drop like beats—\nSelfie queen with samurai\nvibes and glitter shoes."
  },
  {
    key: "naoko",
    name: "Naoko Ishikawa",
    description:
      "Whiskey breath ignites—\nLove burns like microwave fish.\nCareful. I spark quick."
  },
  {
    key: "hana",
    name: "Hana Matsuda",
    description:
      "Ink beneath her skin—\nTruths with a sizzling side eye.\nDid you feel that too?"
  },
  {
    key: "oldman",
    name: "Tetsuya Ito",
    description:
      "Fed birds. Loved one wife.\nSpoke of days when boats still sang.\nNow? I only was."
  },
  {
    key: "player",
    name: "Randy Weston",
    description:
      "Beer gut full of charm—\nStill single, still in America.\nCall me maybe, bro."
  }
];
